/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateTenantRequest,
  LegalHoldRequest,
  RetentionOverrideRequest,
  TenantDecommissionVerificationDto,
  TenantListResponse,
  TenantResponse,
  UpdateTenantRequest,
} from '../models/index';
import {
    CreateTenantRequestFromJSON,
    CreateTenantRequestToJSON,
    LegalHoldRequestFromJSON,
    LegalHoldRequestToJSON,
    RetentionOverrideRequestFromJSON,
    RetentionOverrideRequestToJSON,
    TenantDecommissionVerificationDtoFromJSON,
    TenantDecommissionVerificationDtoToJSON,
    TenantListResponseFromJSON,
    TenantListResponseToJSON,
    TenantResponseFromJSON,
    TenantResponseToJSON,
    UpdateTenantRequestFromJSON,
    UpdateTenantRequestToJSON,
} from '../models/index';

export interface CancelScheduledDecommissionRequest {
    id: string;
    sessionId?: string;
}

export interface CreateTenantOperationRequest {
    createTenantRequest: CreateTenantRequest;
    sessionId?: string;
}

export interface DecommissionTenantRequest {
    id: string;
    sessionId?: string;
}

export interface DeleteTenantRequest {
    id: string;
    sessionId?: string;
}

export interface GetTenantRequest {
    id: string;
    sessionId?: string;
}

export interface GetTenantsRequest {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    name?: string;
    status?: string;
    includeDecommissioned?: boolean;
    sessionId?: string;
}

export interface RestoreTenantRequest {
    id: string;
    sessionId?: string;
}

export interface ScheduleDecommissionTenantRequest {
    id: string;
    sessionId?: string;
}

export interface SetLegalHoldRequest {
    id: string;
    legalHoldRequest: LegalHoldRequest;
    sessionId?: string;
}

export interface SetRetentionOverrideDaysRequest {
    id: string;
    retentionOverrideRequest: RetentionOverrideRequest;
    sessionId?: string;
}

export interface SetRetentionOverrideUntilRequest {
    id: string;
    retentionOverrideRequest: RetentionOverrideRequest;
    sessionId?: string;
}

export interface UpdateTenantOperationRequest {
    id: string;
    updateTenantRequest: UpdateTenantRequest;
    sessionId?: string;
}

export interface VerifyTenantDecommissionRequest {
    id: string;
    sessionId?: string;
}

/**
 * TenantsApi - interface
 * 
 * @export
 * @interface TenantsApiInterface
 */
export interface TenantsApiInterface {
    /**
     * Cancels a scheduled decommission, restoring tenant to normal operation
     * @summary Cancel scheduled decommission
     * @param {string} id Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    cancelScheduledDecommissionRaw(requestParameters: CancelScheduledDecommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Cancels a scheduled decommission, restoring tenant to normal operation
     * Cancel scheduled decommission
     */
    cancelScheduledDecommission(requestParameters: CancelScheduledDecommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates a new tenant (backoffice/admin-only).  Usage guidance: This endpoint is intended for backoffice/system administration workflows. For full customer onboarding (admin user creation, domain mapping, identity provider setup), use the self-service enrollment endpoint `POST /v1/enrollment/tenant`.  Behavior notes: - If `customerId` is provided or `settings.skipEnrollment=true`, a tenant record is created immediately with `enrollmentStatus=active` and `enrollmentDate` stamped. - If the referenced customer has a primary contact whose email already exists as a user, the system will set `admin_user_id` to that user\'s UUID, ensure a `user_tenant` membership, and ensure/assign the `TENANT_ADMIN` role. - Optional: set `settings.autoCreateAdminUser=true` to automatically create a local admin user from the customer\'s primary contact if the user does not already exist.
     * @summary Create tenant
     * @param {CreateTenantRequest} createTenantRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    createTenantRaw(requestParameters: CreateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>>;

    /**
     * Creates a new tenant (backoffice/admin-only).  Usage guidance: This endpoint is intended for backoffice/system administration workflows. For full customer onboarding (admin user creation, domain mapping, identity provider setup), use the self-service enrollment endpoint `POST /v1/enrollment/tenant`.  Behavior notes: - If `customerId` is provided or `settings.skipEnrollment=true`, a tenant record is created immediately with `enrollmentStatus=active` and `enrollmentDate` stamped. - If the referenced customer has a primary contact whose email already exists as a user, the system will set `admin_user_id` to that user\'s UUID, ensure a `user_tenant` membership, and ensure/assign the `TENANT_ADMIN` role. - Optional: set `settings.autoCreateAdminUser=true` to automatically create a local admin user from the customer\'s primary contact if the user does not already exist.
     * Create tenant
     */
    createTenant(requestParameters: CreateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse>;

    /**
     * Suspends tenant immediately, revokes bindings and user access, invalidates sessions, and schedules purge after retention. Use schedule-decommission for grace period.
     * @summary Decommission tenant
     * @param {string} id Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    decommissionTenantRaw(requestParameters: DecommissionTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Suspends tenant immediately, revokes bindings and user access, invalidates sessions, and schedules purge after retention. Use schedule-decommission for grace period.
     * Decommission tenant
     */
    decommissionTenant(requestParameters: DecommissionTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Deletes a tenant
     * @summary Delete tenant
     * @param {string} id Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    deleteTenantRaw(requestParameters: DeleteTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a tenant
     * Delete tenant
     */
    deleteTenant(requestParameters: DeleteTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves a specific tenant by ID
     * @summary Get tenant by ID
     * @param {string} id Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    getTenantRaw(requestParameters: GetTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>>;

    /**
     * Retrieves a specific tenant by ID
     * Get tenant by ID
     */
    getTenant(requestParameters: GetTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse>;

    /**
     * Retrieves paginated list of tenants
     * @summary Get tenants
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [name] Name filter
     * @param {string} [status] Status filter
     * @param {boolean} [includeDecommissioned] Include decommissioned tenants (default: false)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    getTenantsRaw(requestParameters: GetTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantListResponse>>;

    /**
     * Retrieves paginated list of tenants
     * Get tenants
     */
    getTenants(requestParameters: GetTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantListResponse>;

    /**
     * Restores a decommissioned tenant to active state and reactivates all soft-deleted resources (domain bindings, user memberships, groups, roles, configurations, etc.). Resources that were hard-deleted (CustomerTenant, RolePermissions, TenantRelationships, Casbin policies) are not automatically restored and may require manual reconfiguration.
     * @summary Restore decommissioned tenant
     * @param {string} id Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    restoreTenantRaw(requestParameters: RestoreTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>>;

    /**
     * Restores a decommissioned tenant to active state and reactivates all soft-deleted resources (domain bindings, user memberships, groups, roles, configurations, etc.). Resources that were hard-deleted (CustomerTenant, RolePermissions, TenantRelationships, Casbin policies) are not automatically restored and may require manual reconfiguration.
     * Restore decommissioned tenant
     */
    restoreTenant(requestParameters: RestoreTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse>;

    /**
     * Schedules tenant for decommissioning after grace period (default 15 days). Tenant remains active during grace period and can be restored.
     * @summary Schedule tenant decommission
     * @param {string} id Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    scheduleDecommissionTenantRaw(requestParameters: ScheduleDecommissionTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Schedules tenant for decommissioning after grace period (default 15 days). Tenant remains active during grace period and can be restored.
     * Schedule tenant decommission
     */
    scheduleDecommissionTenant(requestParameters: ScheduleDecommissionTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Enable or disable legal hold to prevent purge after decommission
     * @summary Set tenant legal hold
     * @param {string} id Tenant ID
     * @param {LegalHoldRequest} legalHoldRequest Legal hold request body
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    setLegalHoldRaw(requestParameters: SetLegalHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>>;

    /**
     * Enable or disable legal hold to prevent purge after decommission
     * Set tenant legal hold
     */
    setLegalHold(requestParameters: SetLegalHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse>;

    /**
     * Set retention override in days, null to clear. Clears absolute until when set.
     * @summary Set tenant retention override (days)
     * @param {string} id Tenant ID
     * @param {RetentionOverrideRequest} retentionOverrideRequest Retention override request body
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    setRetentionOverrideDaysRaw(requestParameters: SetRetentionOverrideDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>>;

    /**
     * Set retention override in days, null to clear. Clears absolute until when set.
     * Set tenant retention override (days)
     */
    setRetentionOverrideDays(requestParameters: SetRetentionOverrideDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse>;

    /**
     * Set absolute purge-not-before timestamp, null to clear. Clears days when set.
     * @summary Set tenant retention override (absolute until)
     * @param {string} id Tenant ID
     * @param {RetentionOverrideRequest} retentionOverrideRequest Retention override request body
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    setRetentionOverrideUntilRaw(requestParameters: SetRetentionOverrideUntilRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>>;

    /**
     * Set absolute purge-not-before timestamp, null to clear. Clears days when set.
     * Set tenant retention override (absolute until)
     */
    setRetentionOverrideUntil(requestParameters: SetRetentionOverrideUntilRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse>;

    /**
     * Updates tenant information
     * @summary Update tenant
     * @param {string} id Tenant ID
     * @param {UpdateTenantRequest} updateTenantRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    updateTenantRaw(requestParameters: UpdateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>>;

    /**
     * Updates tenant information
     * Update tenant
     */
    updateTenant(requestParameters: UpdateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse>;

    /**
     * Verifies that a tenant has been properly decommissioned by checking:  - Tenant status (should be suspended/inactive with decommissionedAt set) - Active user-tenant associations (should be 0) - Active sessions (should be 0) - Domain bindings (should be 0)  Returns a detailed report with any issues found. Useful for: - Post-decommission verification - Troubleshooting incomplete decommissions - Compliance audits - Pre-purge validation
     * @summary Verify tenant decommission status
     * @param {string} id Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    verifyTenantDecommissionRaw(requestParameters: VerifyTenantDecommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDecommissionVerificationDto>>;

    /**
     * Verifies that a tenant has been properly decommissioned by checking:  - Tenant status (should be suspended/inactive with decommissionedAt set) - Active user-tenant associations (should be 0) - Active sessions (should be 0) - Domain bindings (should be 0)  Returns a detailed report with any issues found. Useful for: - Post-decommission verification - Troubleshooting incomplete decommissions - Compliance audits - Pre-purge validation
     * Verify tenant decommission status
     */
    verifyTenantDecommission(requestParameters: VerifyTenantDecommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDecommissionVerificationDto>;

}

/**
 * 
 */
export class TenantsApi extends runtime.BaseAPI implements TenantsApiInterface {

    /**
     * Cancels a scheduled decommission, restoring tenant to normal operation
     * Cancel scheduled decommission
     */
    async cancelScheduledDecommissionRaw(requestParameters: CancelScheduledDecommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cancelScheduledDecommission().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{id}/cancel-scheduled-decommission`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancels a scheduled decommission, restoring tenant to normal operation
     * Cancel scheduled decommission
     */
    async cancelScheduledDecommission(requestParameters: CancelScheduledDecommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelScheduledDecommissionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new tenant (backoffice/admin-only).  Usage guidance: This endpoint is intended for backoffice/system administration workflows. For full customer onboarding (admin user creation, domain mapping, identity provider setup), use the self-service enrollment endpoint `POST /v1/enrollment/tenant`.  Behavior notes: - If `customerId` is provided or `settings.skipEnrollment=true`, a tenant record is created immediately with `enrollmentStatus=active` and `enrollmentDate` stamped. - If the referenced customer has a primary contact whose email already exists as a user, the system will set `admin_user_id` to that user\'s UUID, ensure a `user_tenant` membership, and ensure/assign the `TENANT_ADMIN` role. - Optional: set `settings.autoCreateAdminUser=true` to automatically create a local admin user from the customer\'s primary contact if the user does not already exist.
     * Create tenant
     */
    async createTenantRaw(requestParameters: CreateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        if (requestParameters['createTenantRequest'] == null) {
            throw new runtime.RequiredError(
                'createTenantRequest',
                'Required parameter "createTenantRequest" was null or undefined when calling createTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTenantRequestToJSON(requestParameters['createTenantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new tenant (backoffice/admin-only).  Usage guidance: This endpoint is intended for backoffice/system administration workflows. For full customer onboarding (admin user creation, domain mapping, identity provider setup), use the self-service enrollment endpoint `POST /v1/enrollment/tenant`.  Behavior notes: - If `customerId` is provided or `settings.skipEnrollment=true`, a tenant record is created immediately with `enrollmentStatus=active` and `enrollmentDate` stamped. - If the referenced customer has a primary contact whose email already exists as a user, the system will set `admin_user_id` to that user\'s UUID, ensure a `user_tenant` membership, and ensure/assign the `TENANT_ADMIN` role. - Optional: set `settings.autoCreateAdminUser=true` to automatically create a local admin user from the customer\'s primary contact if the user does not already exist.
     * Create tenant
     */
    async createTenant(requestParameters: CreateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.createTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Suspends tenant immediately, revokes bindings and user access, invalidates sessions, and schedules purge after retention. Use schedule-decommission for grace period.
     * Decommission tenant
     */
    async decommissionTenantRaw(requestParameters: DecommissionTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling decommissionTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{id}/decommission`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Suspends tenant immediately, revokes bindings and user access, invalidates sessions, and schedules purge after retention. Use schedule-decommission for grace period.
     * Decommission tenant
     */
    async decommissionTenant(requestParameters: DecommissionTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.decommissionTenantRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a tenant
     * Delete tenant
     */
    async deleteTenantRaw(requestParameters: DeleteTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a tenant
     * Delete tenant
     */
    async deleteTenant(requestParameters: DeleteTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTenantRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a specific tenant by ID
     * Get tenant by ID
     */
    async getTenantRaw(requestParameters: GetTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific tenant by ID
     * Get tenant by ID
     */
    async getTenant(requestParameters: GetTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.getTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of tenants
     * Get tenants
     */
    async getTenantsRaw(requestParameters: GetTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['includeDecommissioned'] != null) {
            queryParameters['includeDecommissioned'] = requestParameters['includeDecommissioned'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of tenants
     * Get tenants
     */
    async getTenants(requestParameters: GetTenantsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantListResponse> {
        const response = await this.getTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Restores a decommissioned tenant to active state and reactivates all soft-deleted resources (domain bindings, user memberships, groups, roles, configurations, etc.). Resources that were hard-deleted (CustomerTenant, RolePermissions, TenantRelationships, Casbin policies) are not automatically restored and may require manual reconfiguration.
     * Restore decommissioned tenant
     */
    async restoreTenantRaw(requestParameters: RestoreTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling restoreTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{id}/restore`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Restores a decommissioned tenant to active state and reactivates all soft-deleted resources (domain bindings, user memberships, groups, roles, configurations, etc.). Resources that were hard-deleted (CustomerTenant, RolePermissions, TenantRelationships, Casbin policies) are not automatically restored and may require manual reconfiguration.
     * Restore decommissioned tenant
     */
    async restoreTenant(requestParameters: RestoreTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.restoreTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schedules tenant for decommissioning after grace period (default 15 days). Tenant remains active during grace period and can be restored.
     * Schedule tenant decommission
     */
    async scheduleDecommissionTenantRaw(requestParameters: ScheduleDecommissionTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling scheduleDecommissionTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{id}/schedule-decommission`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Schedules tenant for decommissioning after grace period (default 15 days). Tenant remains active during grace period and can be restored.
     * Schedule tenant decommission
     */
    async scheduleDecommissionTenant(requestParameters: ScheduleDecommissionTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.scheduleDecommissionTenantRaw(requestParameters, initOverrides);
    }

    /**
     * Enable or disable legal hold to prevent purge after decommission
     * Set tenant legal hold
     */
    async setLegalHoldRaw(requestParameters: SetLegalHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setLegalHold().'
            );
        }

        if (requestParameters['legalHoldRequest'] == null) {
            throw new runtime.RequiredError(
                'legalHoldRequest',
                'Required parameter "legalHoldRequest" was null or undefined when calling setLegalHold().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{id}/legal-hold`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LegalHoldRequestToJSON(requestParameters['legalHoldRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Enable or disable legal hold to prevent purge after decommission
     * Set tenant legal hold
     */
    async setLegalHold(requestParameters: SetLegalHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.setLegalHoldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set retention override in days, null to clear. Clears absolute until when set.
     * Set tenant retention override (days)
     */
    async setRetentionOverrideDaysRaw(requestParameters: SetRetentionOverrideDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setRetentionOverrideDays().'
            );
        }

        if (requestParameters['retentionOverrideRequest'] == null) {
            throw new runtime.RequiredError(
                'retentionOverrideRequest',
                'Required parameter "retentionOverrideRequest" was null or undefined when calling setRetentionOverrideDays().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{id}/retention-override/days`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RetentionOverrideRequestToJSON(requestParameters['retentionOverrideRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Set retention override in days, null to clear. Clears absolute until when set.
     * Set tenant retention override (days)
     */
    async setRetentionOverrideDays(requestParameters: SetRetentionOverrideDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.setRetentionOverrideDaysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set absolute purge-not-before timestamp, null to clear. Clears days when set.
     * Set tenant retention override (absolute until)
     */
    async setRetentionOverrideUntilRaw(requestParameters: SetRetentionOverrideUntilRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setRetentionOverrideUntil().'
            );
        }

        if (requestParameters['retentionOverrideRequest'] == null) {
            throw new runtime.RequiredError(
                'retentionOverrideRequest',
                'Required parameter "retentionOverrideRequest" was null or undefined when calling setRetentionOverrideUntil().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{id}/retention-override/until`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RetentionOverrideRequestToJSON(requestParameters['retentionOverrideRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Set absolute purge-not-before timestamp, null to clear. Clears days when set.
     * Set tenant retention override (absolute until)
     */
    async setRetentionOverrideUntil(requestParameters: SetRetentionOverrideUntilRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.setRetentionOverrideUntilRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates tenant information
     * Update tenant
     */
    async updateTenantRaw(requestParameters: UpdateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTenant().'
            );
        }

        if (requestParameters['updateTenantRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTenantRequest',
                'Required parameter "updateTenantRequest" was null or undefined when calling updateTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTenantRequestToJSON(requestParameters['updateTenantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Updates tenant information
     * Update tenant
     */
    async updateTenant(requestParameters: UpdateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.updateTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verifies that a tenant has been properly decommissioned by checking:  - Tenant status (should be suspended/inactive with decommissionedAt set) - Active user-tenant associations (should be 0) - Active sessions (should be 0) - Domain bindings (should be 0)  Returns a detailed report with any issues found. Useful for: - Post-decommission verification - Troubleshooting incomplete decommissions - Compliance audits - Pre-purge validation
     * Verify tenant decommission status
     */
    async verifyTenantDecommissionRaw(requestParameters: VerifyTenantDecommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDecommissionVerificationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling verifyTenantDecommission().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{id}/verify-decommission`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantDecommissionVerificationDtoFromJSON(jsonValue));
    }

    /**
     * Verifies that a tenant has been properly decommissioned by checking:  - Tenant status (should be suspended/inactive with decommissionedAt set) - Active user-tenant associations (should be 0) - Active sessions (should be 0) - Domain bindings (should be 0)  Returns a detailed report with any issues found. Useful for: - Post-decommission verification - Troubleshooting incomplete decommissions - Compliance audits - Pre-purge validation
     * Verify tenant decommission status
     */
    async verifyTenantDecommission(requestParameters: VerifyTenantDecommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDecommissionVerificationDto> {
        const response = await this.verifyTenantDecommissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
